import React from "react";
import { Route } from "react-router-dom";
import ChangePassword from "../sections/changepassword";
import Dashboard from "../views/Dashboard";
import AddEmployee from "../views/AddEmployee";
import ViewEmployees from "../views/ViewEmployees";
import EmployeeMenu from "../views/EmployeeMenu";
import EmployeePermission from "../views/EmployeePermission";

const EmployeeRoutes = [
    <Route path="change-password" element={<ChangePassword />} />,
    <Route path="dashboard" element={<Dashboard />} />,
    <Route path="employee/permission" element={<EmployeePermission />} />,
    <Route path="users/add/:id?" element={<AddEmployee />} />,
    <Route path="users/view" element={<ViewEmployees />} />,
    <Route path="employee/menu/:id?" element={<EmployeeMenu />} />
];

export default EmployeeRoutes;
